






































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import userModel from '@/store/modules/user';
import * as apiRequest from '@/utils/apiRequest';
import axios from 'axios';
import SessionModule from '@/store/modules/session';
import { ILoginReturnData } from '@/utils/apiRequest';
import { ApiResponseData } from '@/utils/apiModels';
import { apiSendAsync } from '@/utils/apiRequest';

@Component({})
export default class LoginComponent extends Vue {
  isloading = false;
  form?: any;
  mounted() {}
  beforeCreate() {
    this.form = this.$form.createForm(this);
  }
  handleSubmit(e: any) {
    e.preventDefault();
  }
  async login() {
    this.form.validateFields(async (err: string, values: any) => {
      if (!err) {
        this.isloading = true;
        const result = await api.Clients.validateLogon_POST({ username: values.username, password: values.password });
        if (result && result.success) {
          const data = result.data! as any;
          const token = data.token;
          let time = new Date(new Date().getTime() + 7200 * 1000);
          await userModel.SetData({
            refresh_token: '',
            expires_time: time,
            token: token,
            name: data.name.Text,
            userId: data.Id,
            username: data.username,
            deptName: data.deptName,
          });

          SessionModule.ACTIVE_USER({
            userId: data.Id,
            userName: data.username,
            name: data.name.Text,
            token: token,
            refresh_token: '',
            expires_time: time,
            deptName: data.deptName,
          });

          const to =
            this.$route.query.redirect && this.$route.query.redirect !== '/404'
              ? this.$route.query.redirect
              : '/manage';

          console.log('para:', this.$route.query, ', to:', to);

          this.$router.push(to as any);
          //location.href = '#/manage';
          this.isloading = false;
        } else {
          this.isloading = false;
          this.$message.error(result.message);
        }
      } else {
        this.$message.error('请输入账号密码');
      }
    });
  }
  handleCodeOk(d: any) {
    console.log('d', d);
    this.login();
  }
}
